// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/circle-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/mob-circle-pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patternBg{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}

.circle-pattern{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
@media (max-width: 640px){
  .circle-pattern{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}

.feature-pack-text{
  transition: .5s ease;
  opacity: 0;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.30);
  background: rgba(255, 255, 255, 0.10);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);    
}

.feature-pack:hover .feature-pack-text{
  opacity: 1;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.featureOptions::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  .featureOptions {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

.drop-shadow{
  border-radius: 24px;
  box-shadow: 0px 4px 10px 0px rgba(167, 119, 238, 0.15);
}

.ant-modal-content{
  padding: 0 !important;
}

.login-btn{
  border-radius: 8px;
  border: 1px solid #F0E8FC;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(167, 119, 238, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  color: #1D2939;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.css"],"names":[],"mappings":"AAAA;EACE,yDAA+C;EAC/C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAsD;EACtD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE;IACE,yDAA0D;EAC5D;AACF;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;IACI,aAAa;EACf;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;EACtC;;AAEF;EACE,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sDAAsD;EACtD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".patternBg{\n  background-image: url(../../assets/pattern.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.circle-pattern{\n  background-image: url(../../assets/circle-pattern.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n@media (max-width: 640px){\n  .circle-pattern{\n    background-image: url(../../assets/mob-circle-pattern.png);\n  }\n}\n\n.feature-pack-text{\n  transition: .5s ease;\n  opacity: 0;\n  border-radius: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.30);\n  background: rgba(255, 255, 255, 0.10);\n  backdrop-filter: blur(20px);    \n}\n\n.feature-pack:hover .feature-pack-text{\n  opacity: 1;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.featureOptions::-webkit-scrollbar {\n    display: none;\n  }\n  \n  /* Hide scrollbar for IE, Edge and Firefox */\n  .featureOptions {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n  }\n\n.drop-shadow{\n  border-radius: 24px;\n  box-shadow: 0px 4px 10px 0px rgba(167, 119, 238, 0.15);\n}\n\n.ant-modal-content{\n  padding: 0 !important;\n}\n\n.login-btn{\n  border-radius: 8px;\n  border: 1px solid #F0E8FC;\n  background: #FFF;\n  box-shadow: 0px 4px 10px 0px rgba(167, 119, 238, 0.15);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  color: #1D2939;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
